// Régua canônica para decidir como buscar um produto a partir de um termo
// livre digitado pelo usuário (nome, código ou EAN).
//
// Hoje esta mesma decisão existe em mais duas telas com réguas divergentes:
// - src/views/Colaboradores/components/MixProdutos.vue (~210-211): trata
//   QUALQUER numérico como código de produto — um EAN digitado ali não acha
//   nada.
// - src/views/Produtos/Produtos.vue (~258-260): manda produto_id e termo na
//   mesma requisição.
// Ao tocar em qualquer uma delas, prefira migrar para este helper em vez de
// criar uma quinta variação da regra.
//
// Numérico com 8+ dígitos é tratado como EAN (busca exata por código de
// barras, conferida no cliente porque a API sem filtros[ean] ignora o
// parâmetro e devolve a primeira página do catálogo); numérico mais curto é
// código do produto; o resto busca por descrição.
export function filtroBuscaProduto(termo) {
  const valor = (termo || '').trim();
  const isNumeric = /^\d+$/.test(valor);
  const conferirCodBarra = isNumeric && valor.length >= 8;

  let filtro;
  if (conferirCodBarra) {
    filtro = `filtros[ean]=${valor}`;
  } else if (isNumeric) {
    filtro = `filtros[produto_id]=${valor}`;
  } else {
    filtro = `filtros[termo]=${encodeURIComponent(valor)}`;
  }

  return { filtro, conferirCodBarra };
}
